"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
class Button extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.onClickButton = this.onClickButton.bind(this);
    }
    onClickButton(event) {
        event.preventDefault();
        if (typeof this.props.onClick === 'function') {
            this.props.onClick(event);
        }
    }
    render() {
        if (this.props.isVisible === false) {
            return null;
        }
        if (this.props.type === 'href' && this.props.href) {
            const attributes = {
                href: this.props.href,
                className: `button ${this.props.color} ${this.props.size}`
            };
            if (this.props.download) {
                attributes.download = this.props.download;
            }
            return (react_1.default.createElement("div", { className: this.props.align, style: this.props.style || {} },
                react_1.default.createElement("a", Object.assign({}, attributes),
                    this.props.icon && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: this.props.icon, className: `${this.props.iconClass}` })),
                    this.props.iconPath && (react_1.default.createElement("img", { className: `_icon ${this.props.iconClass}`, src: this.props.iconPath, alt: this.props.label })),
                    ' ',
                    this.props.label)));
        }
        else if (this.props.type !== 'href') {
            const attributes = {};
            if (this.props.disabled) {
                attributes.disabled = true;
            }
            if (this.props.title) {
                attributes.title = this.props.title;
            }
            if (this.props.name) {
                attributes.name = this.props.name;
            }
            if (this.props.onKeyUp) {
                attributes.onKeyUp = this.props.onKeyUp;
            }
            return (react_1.default.createElement("div", { className: this.props.align, style: this.props.style || {} },
                react_1.default.createElement("button", Object.assign({}, attributes, { type: this.props.type, ref: this.props.inputRef, className: `button ${this.props.color} ${this.props.size}${this.props.disabled ? ' disabled' : ''}`, onClick: this.onClickButton }),
                    this.props.icon && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: this.props.icon, className: `${this.props.iconClass}` })),
                    this.props.iconPath && (react_1.default.createElement("img", { className: `_icon ${this.props.iconClass}`, src: this.props.iconPath, alt: this.props.label })),
                    ' ',
                    this.props.label)));
        }
    }
}
exports.Button = Button;
Button.defaultProps = {
    isVisible: true,
    align: 'center',
    type: 'button',
    color: 'green',
    size: 'large',
    iconClass: '_icon',
    style: {},
    title: undefined,
    name: undefined,
    disabled: false
};
exports.default = Button;
//# sourceMappingURL=Button.js.map